<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="统计时间" prop="date">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width: 60rem; float: left"
              unlink-panels
              :clearable="false"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label>
            <el-button @click="onSearch" style="float: left">搜 索</el-button>
          </el-form-item>
        </el-form>

        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main style="padding-top: 0; overflow-y: auto">
        <div class="config-header" style="height: 100%">
          <div class="detail-header">
            <span class="header-title">喷灌用水量</span>
            <div class="arrow-pic"></div>
          </div>

          <div class="config-content" style="height: 100%">
            <div class="analysis_chart">
              <div style="width: 100%; height: 100%">
                总喷灌用水量（吨）：{{ totalNum }}
                <LineEchart3
                  title=""
                  xAxisName="日期"
                  yAxisName="吨"
                  :chartData="analysisData"
                ></LineEchart3>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import { getEquipmentCode, listAggregationDay } from "@/api/src/equipment";

export default {
  name: "IrrigationAnalysis",
  componentName: "IrrigationAnalysis",

  // 可接收 URL 参数。
  // 仅当通过 url 跳转的时候可接收这些参数。
  // 也可通过 this.$route.query 来查询 url 参数。
  props: {},
  data() {
    return {
      loading: false,

      date: [
        new Date(new Date() - 7 * 24 * 60 * 60 * 1000),
        new Date(new Date() - 1 * 24 * 60 * 60 * 1000),
      ],
      totalNum: 0, //总喷灌用水
      analysisData: {
        days: [],
        data: [],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > new Date().getTime() - 3600 * 1000 * 24;
        },
      },
    };
  },
  methods: {
    // 获取设备code
    init() {
      getEquipmentCode("waterEquipment").then((response) => {
        this.code = response.data;
        this.onSearch();
      });
    },

    onSearch() {
      this.loading = true;
      const searchInfo = {
        startTs:
          this.date == null ? "0001-01-01T00:00:00" : this.date[0].getTime(),
        endTs:
          this.date == null ? "0001-01-01T00:00:00" : this.date[1].getTime(),
        pageSize: 10000,
        categoryCode: this.code,
        countType: "water",
      };

      listAggregationDay(searchInfo)
        .then((response) => {
          let days = [],
            data = [],
            totalNum = 0;

          response.data.forEach((item) => {
            days.push(item.statDay);
            data.push(item.statCount);
            totalNum += item.statCount; //计算总喷灌用水量
          });
          this.analysisData = { days: days, data: data };
          this.totalNum = totalNum;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.init();
    this.logInfo.ActionName = "灌溉统计";
    this.logInfo.LogMessage = "灌溉统计";
    this.logInfo.ModuleName = "智能控制";
    this.logInfo.PageName = "灌溉统计";
    this.addOperationLog();
  },
  beforeDestroy() {},
  destroyed() {},
  controller: "UI",
  action: "IrrigationAnalysis",
};
</script>

<style scoped>
.zj-vehicleview-root {
  height: 100%;
  width: 100%;
  position: relative;
}
</style>
